import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["initialEnable"];
import { useFlag } from '@carnica/utils/hooks';
import React, { useCallback } from 'react';
export function withFlag(WrappedComponent) {
  return function (_ref) {
    var initialEnable = _ref.initialEnable,
      props = _objectWithoutProperties(_ref, _excluded);
    var _useFlag = useFlag(initialEnable),
      _useFlag2 = _slicedToArray(_useFlag, 2),
      isEnable = _useFlag2[0],
      setIsEnable = _useFlag2[1];
    var handleClick = useCallback(function () {
      var _props$onClick;
      setIsEnable.toggle();
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props);
    }, [props, setIsEnable]);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      isEnable: isEnable,
      onClick: handleClick,
      "data-t-id": "utils-hocs"
    }));
  };
}